import { createAction } from '@reduxjs/toolkit';
import { Project } from '../../api';
import { ProjectShape } from './model';

export const loadProjectsRequested = createAction<{ saveLastState: boolean }>(
  'al/project/loadProjectsRequested',
);

export const projectsChanged = createAction<{ projects: Project[] }>('al/project/projectsChanged');

export const projectIdsSelected = createAction<{
  ids: Project['id'][];
  saveLastState: boolean;
  preserveSearch?: boolean;
}>('al/project/projectIdsSelected');

export const setLoading = createAction<{ loading: boolean }>('al/project/setLoading');

export const expandedChanged = createAction<{ expanded: ProjectShape['expanded'] }>(
  'al/project/expandedChanged',
);
